export default "__VITE_ASSET__ffMcIyll__"